<template>
  <div class="emergency-info-management">
    <!-- 标题区域 -->
    <div class="header-section">
   
      <div class="tab-navigation">
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 'company' }"
          @click="switchTab('company')"
        >
          企业信息
        </div>
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 'surrounding' }"
          @click="switchTab('surrounding')"
        >
          周边信息
        </div>
        <!-- <div 
          class="tab-item" 
          :class="{ active: activeTab === 'firefighters' }"
          @click="switchTab('firefighters')"
        >
          义务消防员
        </div> -->
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-section">
      <!-- 企业信息 -->
      <div v-if="activeTab === 'company'" class="tab-content company-info">
        <div class="form-section">
          <div class="form-grid">
            <div class="form-group">
              <label class="form-label required">应急指挥部电话</label>
              <el-input 
                v-model="form.emergency_command_phone" 
                placeholder="请输入应急指挥部电话"
                clearable
              />
            </div>
            <div class="form-group">
              <label class="form-label required">应急值班电话</label>
              <el-input 
                v-model="form.emergency_duty_phone" 
                placeholder="请输入应急值班电话"
                clearable
              />
            </div>
            <div class="form-group full-width">
              <label class="form-label required">主要运输线路</label>
              <el-input 
                v-model="form.main_transport_route" 
                placeholder="请输入主要运输线路"
                type="textarea"
                :rows="2"
              />
            </div>
            <div class="form-group full-width">
              <label class="form-label required">主要运输货物</label>
              <el-input 
                v-model="form.main_transport_goods" 
                placeholder="请输入主要运输货物"
                type="textarea"
                :rows="2"
              />
            </div>
      
                <div class="form-group full-width">
              <label class="form-label">周边应急力量简介</label>
              <el-input 
                v-model="form.surrounding_resources" 
                placeholder="请输入备注信息"
                type="textarea"
                :rows="3"
              />
            </div>
          </div>
          
          <div class="form-actions">

            <el-button type="primary" @click="saveCompanyInfo">保存</el-button>
          </div>
        </div>
      </div>

      <!-- 周边信息 -->
   
                <div v-if="activeTab === 'surrounding'" class="tab-content surrounding-info">
                    <div class="form-section">
                    <div class="form-header">
                        <div class="form-title">关键路线、标识和图纸</div>
                        <el-button type="primary" icon="el-icon-plus" @click="addSurroundingInfo">
                        添加信息
                        </el-button>
                    </div>
                    
                    <!-- 信息列表 -->
                    <div class="info-list">
                        <div v-for="(item, index) in form.surroundingInfoList" :key="index" class="info-card">
                        <div class="info-header">
                            <div class="info-title">{{ item.name || '未命名' }}</div>
                            <div class="info-actions">
                            <el-button type="text" icon="el-icon-edit" @click="editSurroundingInfo(index)"></el-button>
                            <el-button type="text" icon="el-icon-delete" @click="deleteSurroundingInfo(index)"></el-button>
                            </div>
                        </div>
                        
                        <div class="info-content">
                            <div class="info-row">
                            <span class="label">联系电话：</span>
                            <span class="value">{{ item.phone }}</span>
                            </div>
                            <div class="info-row">
                            <span class="label">备注：</span>
                            <span class="value">{{ item.remark || '无' }}</span>
                            </div>
                            <div class="info-row" v-if="item.images && item.images.length > 0">
                            <span class="label">图片：</span>
                            <div class="image-preview">
                                <div v-for="(img, imgIndex) in item.images" :key="imgIndex" class="image-item">
                                <img :src="img.file_path" :alt="img.real_name" />
                                <div class="image-name">{{ img.real_name }}</div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div> 
                 </div>
            <el-dialog
                title="关键路线、标识和图纸"
                :visible.sync="dialogVisible_sinfo"
                @close="dialogVisible_sinfo_close"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="50%"
            >
                    <!-- 添加/编辑表单 -->
                    <div  class="edit-form">
                        <div class="form-title">{{ isEditing ? '编辑信息' : '添加信息' }}</div>
                        <div class="form-grid">
                        <div class="form-group full-width">
                            <label class="form-label required">名称</label>
                            <el-input 
                            v-model="currentSurroundingInfo.name" 
                            placeholder="医院、派出所等"
                            />
                        </div>
                        <div class="form-group">
                            <label class="form-label required">联系电话</label>
                            <el-input 
                            v-model="currentSurroundingInfo.phone" 
                            width="300"
                            placeholder="例:110/010-1234567/010-12345678/标准手机号等"
                            />
                        </div>
                        <div class="form-group full-width">
                            <label class="form-label">备注</label>
                            <el-input 
                            v-model="currentSurroundingInfo.remark" 
                            placeholder="请输入备注"
                            type="textarea"
                            :rows="2"
                            />
                        </div>
                        <div class="form-group full-width">
                            <label class="form-label">图片</label>
                            <div class="upload-tips">
                            只能上传.png,.jpg,.jpeg文件，且不超过5MB，且最多8个
                            </div>
                             <div class="draggable-list">
                                <draggable class="wrapper" v-model="currentSurroundingInfo.images">
                                <transition-group>
                                    <div v-for="(item, index) in currentSurroundingInfo.images" :key="item.file_path">
                                    <div class="item">
                                        <img v-img-url="item.file_path" alt="file_path"/>
                                        <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
                                    </div>
                                    </div>
                                </transition-group>
                                </draggable>
                                <div class="item img-select" @click="openProductUpload('album')">
                                <i class="el-icon-plus"></i>
                                </div>
                            </div>
                        </div>
                        </div>
                        
                        <div class="form-actions">
                   
                        <el-button type="primary" @click="saveSurroundingInfo">
                            {{ isEditing ? '更新' : '保存' }}
                        </el-button>
                        </div>
                    </div>
                
            </el-dialog>
      








      <!-- 义务消防员 -->
      <!-- <div v-if="activeTab === 'firefighters'" class="tab-content firefighters-info">
        <div class="form-section">
          <div class="form-title">义务消防员管理</div>
          
  
          <div class="filter-section">
            <div class="filter-group">
              <label class="filter-label">姓名</label>
              <el-select 
                v-model="filters.name" 
                placeholder="请选择"
                clearable
                style="width: 200px;"
              >
                <el-option
                  v-for="item in nameOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            
            <div class="filter-group">
              <label class="filter-label">部门</label>
              <el-select 
                v-model="filters.department" 
                placeholder="请选择"
                clearable
                style="width: 200px;"
              >
                <el-option
                  v-for="dept in departmentOptions"
                  :key="dept.value"
                  :label="dept.label"
                  :value="dept.value"
                />
              </el-select>
            </div>
            
            <div class="filter-actions">
              <el-button @click="resetFilters">重置</el-button>
              <el-button type="primary" @click="searchFirefighters">搜索</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="addFirefighter">
                添加消防员
              </el-button>
            </div>
          </div>
    
          <div class="firefighters-list">
            <div v-for="(firefighter, index) in filteredFirefighters" :key="index" class="firefighter-card">
              <div class="firefighter-header">
                <div class="firefighter-name">{{ firefighter.name }}</div>
                <div class="firefighter-actions">
                  <el-button type="text" icon="el-icon-edit" @click="editFirefighter(index)"></el-button>
                  <el-button type="text" icon="el-icon-delete" @click="deleteFirefighter(index)"></el-button>
                </div>
              </div>
              
              <div class="firefighter-info">
                <div class="info-row">
                  <span class="label">部门：</span>
                  <span class="value">{{ firefighter.department }}</span>
                </div>
                <div class="info-row">
                  <span class="label">岗位：</span>
                  <span class="value">{{ firefighter.position }}</span>
                </div>
                <div class="info-row">
                  <span class="label">职务：</span>
                  <span class="value">{{ firefighter.title }}</span>
                </div>
                <div class="info-row">
                  <span class="label">电话：</span>
                  <span class="value">{{ firefighter.phone }}</span>
                </div>
              </div>
            </div>
          </div>
          

          <div v-if="showFirefighterForm" class="edit-form">
            <div class="form-title">{{ isEditingFirefighter ? '编辑消防员' : '添加消防员' }}</div>
            <div class="form-grid">
              <div class="form-group">
                <label class="form-label required">姓名</label>
                <el-input 
                  v-model="currentFirefighter.name" 
                  placeholder="请输入姓名"
                />
              </div>
              <div class="form-group">
                <label class="form-label required">部门</label>
                <el-select 
                  v-model="currentFirefighter.department" 
                  placeholder="请选择"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="dept in departmentOptions"
                    :key="dept.value"
                    :label="dept.label"
                    :value="dept.value"
                  />
                </el-select>
              </div>
              <div class="form-group">
                <label class="form-label">岗位</label>
                <el-input 
                  v-model="currentFirefighter.position" 
                  placeholder="请输入岗位"
                />
              </div>
              <div class="form-group">
                <label class="form-label">职务</label>
                <el-input 
                  v-model="currentFirefighter.title" 
                  placeholder="请输入职务"
                />
              </div>
              <div class="form-group">
                <label class="form-label required">电话</label>
                <el-input 
                  v-model="currentFirefighter.phone" 
                  placeholder="请输入电话"
                />
              </div>
            </div>
            
            <div class="form-actions">
              <el-button @click="cancelFirefighterForm">重置</el-button>
              <el-button type="primary" @click="saveFirefighter">
                {{ isEditingFirefighter ? '更新' : '保存' }}
              </el-button>
            </div>
          </div>
        </div>
      </div> -->
    </div>
        <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js'
import _ from 'lodash'
import Upload from "@/components/file/Upload"


import draggable from "vuedraggable";
export default {
  name: 'EmergencyInfoManagement',
   components: {

     /*图片上传*/
     Upload: Upload,
     draggable,
  },
  data() {
    return {
      activeTab: 'company',
        form:{


              surroundingInfoList: [
                {
                name: '办公场所平面布置图及救援力量分布图',
                phone: '18924651054',
                remark: '',
                images: []
                }
            ],
        },
        dialogVisible_sinfo:false,
        si_index:0,
 
      originalCompanyInfo: {},


      isEditing: false,
      currentSurroundingInfo: {
        name: '',
        phone: '',
        remark: '',
        images: []
      },
      editIndex: -1,
      code:"",
        isProductUpload:false,
      
      // 义务消防员
      firefighters: [
        { name: '测试人员', department: '安全管理员', position: '财务部', title: '', phone: '' },
        { name: '冯杉', department: '安全中心', position: '安全管理员', title: '', phone: '13212344322' },
        { name: '南方', department: '车队', position: '车队长', title: '', phone: '13212344321' },
        { name: '李', department: '人事行政部', position: '', title: '', phone: '15920683311' },
        { name: '邓俊越', department: '运营调度部', position: '', title: '', phone: '13723494631' },
        { name: '邓海柱', department: '安全管理部', position: '', title: '', phone: '13554923786' },
        { name: '吴灏峰', department: '监控中心', position: '', title: '', phone: '18025412078' },
        { name: '李四', department: '运营中心', position: '', title: '', phone: '13751001575' },
        { name: '杨帆', department: '总经理办公室', position: '', title: '', phone: '15800799658' },
        { name: '高苏', department: '财务部', position: '', title: '', phone: '13509691599' }
      ],
      showFirefighterForm: false,
      isEditingFirefighter: false,
      currentFirefighter: {
        name: '',
        department: '',
        position: '',
        title: '',
        phone: ''
      },
      editFirefighterIndex: -1,
      filters: {
        name: '',
        department: ''
      },
      
      // 选项数据
      nameOptions: [
        { value: '测试人员', label: '测试人员' },
        { value: '冯杉', label: '冯杉' },
        { value: '南方', label: '南方' },
        { value: '李', label: '李' },
        { value: '邓俊越', label: '邓俊越' },
        { value: '邓海柱', label: '邓海柱' },
        { value: '吴灏峰', label: '吴灏峰' },
        { value: '李四', label: '李四' },
        { value: '杨帆', label: '杨帆' },
        { value: '高苏', label: '高苏' }
      ],
      departmentOptions: [
        { value: '总经理办公室', label: '总经理办公室' },
        { value: '安全中心', label: '安全中心' },
        { value: '人事行政部', label: '人事行政部' },
        { value: '财务部', label: '财务部' },
        { value: '运营调度部', label: '运营调度部' },
        { value: '安全管理部', label: '安全管理部' },
        { value: '监控中心', label: '监控中心' },
        { value: '车队', label: '车队' },
        { value: '运营中心', label: '运营中心' }
      ]
    };
  },
  computed: {
    filteredFirefighters() {
      return this.firefighters.filter(firefighter => {
        const nameMatch = !this.filters.name || firefighter.name.includes(this.filters.name);
        const deptMatch = !this.filters.department || firefighter.department === this.filters.department;
        return nameMatch && deptMatch;
      });
    }
  },
  mounted() {
      this.getParams()

  },


  methods: {
     /*获取配置数据*/
    getParams() {
      let self = this
      SettingApi.storeDetail({}, true).then(res => {
        if (res.code) {

          self.form = res.data.vars.values
            if(!self.form.surroundingInfoList){
                self.form.surroundingInfoList = [{
                    name: '',
                    phone: '',
                    remark: '',
                    images: []
                }];
            }
        } else {
          self.$message.error('错了哦，这是一条错误消息')
        }
      }).catch(error => {
        console.log(error)
      })
    },

    // 标签页切换
    switchTab(tab) {
      this.activeTab = tab;
    },
    

    saveCompanyInfo() {


      if (!this.form.emergency_command_phone || !this.form.emergency_duty_phone || 
          !this.form.main_transport_route || !this.form.main_transport_goods) {
            this.$message.error('请填写所有必填项');
            return;
        }
        
             let params = this.form
        
         this.editStore(params);
    },
    
    // 周边信息相关方法
    addSurroundingInfo() {
      this.dialogVisible_sinfo = true;
     this.isEditing = false;
    
      this.form.surroundingInfoList.push({
        name: '',
        phone: '',
        remark: '',
        images: []
      });
         this.$forceUpdate();
        this.si_index =   this.form.surroundingInfoList.length-1;

        console.log('填加this.si_index',this.si_index);
    },
       
    editSurroundingInfo(index) {
      this.dialogVisible_sinfo = true;
      this.si_index = index;
      this.isEditing = true;
      
      this.currentSurroundingInfo = this.form.surroundingInfoList[index];
      if(!this.currentSurroundingInfo.images){
        this.currentSurroundingInfo.images = [];
      }
    },
      
    saveSurroundingInfo() {
        var self = this;
        if (!this.currentSurroundingInfo.name || !this.currentSurroundingInfo.phone) {
            this.$message.error('请填写名称和联系电话');
            return;
        }
        console.log('currentSurroundingInfo',this.currentSurroundingInfo);
        this.form.surroundingInfoList[this.si_index] = this.currentSurroundingInfo

        
        console.log('this.si_index',this.si_index);
        this.$forceUpdate();
       let params = this.form
        console.log(' this.form', this.form);
        
        this.editStore(params);

    },
    deleteSurroundingInfo(index) {
      this.$confirm('确定要删除这条信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.surroundingInfoList.splice(index, 1);
         let params = this.form
         this.editStore(params);


      });
    },

    editStore(params){
        var self = this;
      
        // for(var i=0;i<   params.surroundingInfoList.length;i++){
        //         params.surroundingInfoList[i].image = JSON.stringify( params.surroundingInfoList[i].image);
        // }
             SettingApi.editStore(params, true)
            .then(data => {
              self.loading = false
              self.$message({
                message: '恭喜你,操作成功',
                type: 'success',
              })
                self.si_index = -1;
                
           
                self.currentSurroundingInfo =  {
                        name: '',
                        phone: '',
                        remark: '',
                        images: []
                    }
                    self.dialogVisible_sinfo = false;
            })
            .catch(error => {
              self.loading = false
            })
    },
    
    
    dialogVisible_sinfo_close(e){
        console.log(e);
        // if(this.si_index > 0){
        //     this.form.surroundingInfoList.splice(this.si_index,1)
        // }
      
    },
 
    

    clearSurroundingForm() {
      this.currentSurroundingInfo = {
        name: '',
        phone: '',
        remark: '',
        images: []
      };
      this.$message.success('表单已清空');
    },
  
  
    // 文件上传相关方法
    handlePreview(file) {
      // 预览图片
      console.log('预览文件:', file);
    },
    
    handleRemove(file, fileList) {
      // 移除文件
      console.log('移除文件:', file);
    },
    
    beforeUpload(file) {
      const isImage = /\.(png|jpg|jpeg)$/i.test(file.name);
      const isLt5M = file.size / 1024 / 1024 < 5;
      
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB！');
        return false;
      }
      
      // 这里可以添加文件到上传列表
      return false; // 手动上传
    },
    
    // 义务消防员相关方法
    addFirefighter() {
      this.showFirefighterForm = true;
      this.isEditingFirefighter = false;
      this.currentFirefighter = {
        name: '',
        department: '',
        position: '',
        title: '',
        phone: ''
      };
    },
    
    editFirefighter(index) {
      this.showFirefighterForm = true;
      this.isEditingFirefighter = true;
      this.editFirefighterIndex = index;
      this.currentFirefighter = { ...this.firefighters[index] };
    },
    
    deleteFirefighter(index) {
      this.$confirm('确定要删除该义务消防员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.firefighters.splice(index, 1);
        this.$message.success('删除成功');
      });
    },
    
    resetFilters() {
      this.filters = {
        name: '',
        department: ''
      };
    },
    
    searchFirefighters() {
      // 搜索功能已在computed中实现
      this.$message.success('搜索完成');
    },
    
    cancelFirefighterForm() {
      this.currentFirefighter = {
        name: '',
        department: '',
        position: '',
        title: '',
        phone: ''
      };
    },
    
    saveFirefighter() {
      if (!this.currentFirefighter.name || !this.currentFirefighter.department || !this.currentFirefighter.phone) {
        this.$message.error('请填写姓名、部门和电话');
        return;
      }
      
      if (this.isEditingFirefighter) {
        this.firefighters[this.editFirefighterIndex] = { ...this.currentFirefighter };
        this.$message.success('消防员信息更新成功');
      } else {
        this.firefighters.push({ ...this.currentFirefighter });
        this.$message.success('消防员添加成功');
      }
      
      this.showFirefighterForm = false;
    },










       /*打开上传图片*/
     openProductUpload: function (code) {
        this.isProductUpload = true;
        this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

         let imgs = this.currentSurroundingInfo.images.concat(e);
        this.$set(this.currentSurroundingInfo, "images", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.currentSurroundingInfo.images.concat(e);
        this.$set(this.currentSurroundingInfo, "images", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.currentSurroundingInfo.images.splice(index, 1);
      }
      
    },
  }
};
</script>

<style lang="scss" scoped>
.emergency-info-management {
  background: #f6f8fb;
  min-height: 100vh;

}

.header-section {
  background: white;
  border-radius: 2px;
  padding: 10px;


  .page-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin: 0 0 20px 0;
  }
}

.tab-navigation {
  display: flex;
  border-bottom: 1px solid #e4e7ed;
  
  .tab-item {
    padding: 12px 24px;
    cursor: pointer;
    font-size: 14px;
    color: #606266;
    border-bottom: 2px solid transparent;
    transition: all 0.3s;
    
    &:hover {
      color: #409EFF;
    }
    
    &.active {
      color: #409EFF;
      border-bottom-color: #409EFF;
      font-weight: bold;
    }
    
    & + .tab-item {
      margin-left: 20px;
    }
  }
}

.content-section {
  background: white;
  border-radius: 2px;
  padding: 30px;

}

.form-section {
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }
  
  .form-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e4e7ed;
  }
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  
  .form-group {
    &.full-width {
      grid-column: 1 / -1;
    }
  }
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
  
  &.required {
    &::before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}

.form-actions {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
  text-align: right;
  
  .el-button + .el-button {
    margin-left: 10px;
  }
}

// 周边信息样式
.info-list {
  margin-bottom: 30px;
}

.info-card {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  margin-bottom: 16px;
  transition: all 0.3s;
  
  &:hover {
    border-color: #409EFF;
  
  }
  
  .info-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    
    .info-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
    
    .info-actions {
      .el-button {
        padding: 8px;
      }
    }
  }
  
  .info-content {
    padding: 16px;
  }
  
  .info-row {
    margin-bottom: 12px;
    display: flex;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .label {
      color: #606266;
      min-width: 80px;
    }
    
    .value {
      color: #333;
      flex: 1;
    }
  }
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
  
  .image-item {
    width: 100px;
    text-align: center;
    
    img {
      width: 100px;
      height: 100px;
      object-fit: cover;
      border-radius: 4px;
      border: 1px solid #e4e7ed;
    }
    
    .image-name {
      margin-top: 4px;
      font-size: 12px;
      color: #909399;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.upload-tips {
  font-size: 12px;
  color: #909399;
  margin-bottom: 10px;
}

// 义务消防员样式
.filter-section {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-end;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e7ed;
  
  .filter-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    
    .filter-label {
      font-size: 14px;
      color: #606266;
    }
  }
  
  .filter-actions {
    margin-left: auto;
    
    .el-button + .el-button {
      margin-left: 10px;
    }
  }
}

.firefighters-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.firefighter-card {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 16px;
  transition: all 0.3s;
  
  &:hover {
    border-color: #409EFF;
    transform: translateY(-2px);
 
  }
  
  .firefighter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    
    .firefighter-name {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
    
    .firefighter-actions {
      .el-button {
        padding: 4px;
      }
    }
  }
  
  .firefighter-info {
    .info-row {
      display: flex;
      margin-bottom: 8px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .label {
        color: #606266;
        min-width: 40px;
      }
      
      .value {
        color: #333;
        flex: 1;
      }
    }
  }
}

.edit-form {
  margin-top: 30px;
  padding: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  background: #f9fafc;
}

// 响应式设计
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .filter-section {
    flex-direction: column;
    align-items: stretch;
    
    .filter-actions {
      margin-left: 0;
      margin-top: 10px;
    }
  }
  
  .firefighters-list {
    grid-template-columns: 1fr;
  }
}

// 动画效果
.tab-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}




.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/em/index.vue